import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { fetchAttemptedKillEntries } from "@/helper/attemptedKills";
import { ProfileNames } from "@/types/ProfileName";
import { AttemptedKillEntry } from "@/types/AttemptedKillEntry";

export interface AttemptedKillsState {
  entries: AttemptedKillEntry[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AttemptedKillsState = {
  entries: [],
  isLoading: false,
  error: null,
};

export const loadAttemptedKillsAction = createAsyncThunk(
  "attemptedKills/loadAttemptedKills",
  async (profileNames: ProfileNames[]) => {
    return fetchAttemptedKillEntries(profileNames);
  }
);

const attemptedKillsSlice = createSlice({
  name: "attemptedKills",
  initialState,
  reducers: {
    clearAttemptedKills: (state) => {
      state.entries = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttemptedKillsAction.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(loadAttemptedKillsAction.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.entries = payload;
    });
    builder.addCase(loadAttemptedKillsAction.rejected, (state, { error }) => {
      state.isLoading = false;
      state.error = error.message ?? "Failed to load attempted kills";
      state.entries = [];
    });
  },
});

export const { clearAttemptedKills } = attemptedKillsSlice.actions;

export default attemptedKillsSlice.reducer;
